import {
  Alert,
  AlertColor,
  Drawer,
} from "@mui/material";
import EditProfileDialog from "dialogs/EditProfileDialog";
import EditTableNumberDialog from "dialogs/EditTableNumberDialog";
import VideoDialog from "dialogs/VideoDialog";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { useQueryPaymentType } from "services/api/queries/useQueryPaymentTypes";
import {
  IShoppingBagData,
} from "types/ShoppingBag";
import { Snackbar } from "@material-ui/core";
import { useSearchParams } from "react-router-dom";
import CreateAddressDialog from "dialogs/CreateAddressDialog";
import ShoppingBagSkeleton from "./ShoppingBagSkeleton";
import { ICardapioAppState } from "../../redux/RootReducer";
import { UseQueryResult } from "react-query";
import ShoppingBagData from "./ShoppingBagData";
import { EmptyShoppingBag } from "./EmptyShoppingBag";
import ShoppingBagPlaceFechado from "./ShoppingBagPlaceFechado";
import ChangeValueDialog from "../../dialogs/ChangeValueDialog";
import PromptSendOrderViaWhatsapp from "../../dialogs/PromptSendOrderViaWhatsapp";
import { IPaymentType } from "../../types/Payment";

type Props = {
  open: boolean;
  toggleDrawer: () => void;
  anchor?: "right" | "left" | "top" | "bottom" | undefined;
  shoppingBagQuery: UseQueryResult<IShoppingBagData>
};

function ShoppingBag({ open, toggleDrawer, anchor, shoppingBagQuery }: Props) {

  const [searchParams] = useSearchParams();
  const placeId = searchParams.get("place_id");

  const [openDialogEditProfile, setOpenDialogEditProfile] = useState<boolean>(false);

  const [lastOrderState, setLastOrderState] = useState<string>("");

  const [openVideoDialog, setOpenVideoDialog] = useState<boolean>(false);
  const [openCreateAddressDialog, setOpenCreateAddressDialog] = useState<boolean>(false);
  const [openEditTableNumberDialog, setOpenEditTableNumberDialog] = useState<boolean>(false);

  const [openSentViaWhatsAppDialog, setOpenSentViaWhatsAppDialog] = useState<boolean>(false);
  const [openChangeValueDialog, setOpenChangeValueDialog] = useState<boolean>(false);
  const [changeValue, setChangeValue] = useState<bigint>(BigInt(0));

  const [snackbarMessageIsOpen, setSnackbarMessageIsOpen] = useState(false)
  const [snackbarMessageMessage, setSnackbarMessageMessage] = useState("")
  const [snackbarMessageSeverity, setSnackbarMessageSeverity] = useState<AlertColor>('error')

  const { data:shoppingBag, isRefetching: isRefetchingShoppingBag, isLoading: isLoadingShoppingBag} = shoppingBagQuery

  const loginInfo = useSelector((state: ICardapioAppState) => state?.loginInfo);
  const placeInfo = useSelector((state: ICardapioAppState) => state?.placeInfo);

  const paymentTypesQuery
    = useQueryPaymentType(placeId ? Number(placeId) : 445057, 'ShoppingBag');

  const {data: paymentTypeQueryData, refetch: refetchPaymentTypesQuery} = paymentTypesQuery

  useEffect(() => {
    if (
      paymentTypeQueryData?.errors.length &&
      paymentTypeQueryData?.errors.length > 0
    ) {
      refetchPaymentTypesQuery();
    }
  }, [loginInfo]);


  const handleCloseDialogEditProfile = () => {
    setOpenDialogEditProfile(false);
  };
  const handleCloseVideoDialog = () => {
    setOpenVideoDialog(false);
  };
  const handleCloseEditTableNumberDialog = () => {
    setOpenEditTableNumberDialog(false);
  };
  const handleCloseCreateAddressDialog = () => {
    setOpenCreateAddressDialog(!openCreateAddressDialog);
  };

  const handleCloseSentViaWhatsAppDialog = () => {
    setOpenSentViaWhatsAppDialog(false);
  }

  const handleCloseSnackbarMessage = () => {
    setSnackbarMessageMessage("")
    setSnackbarMessageSeverity('error')
    setSnackbarMessageIsOpen(false)
  }

  const showSnackbarMessage = (options:{message: string, severity: AlertColor}) => {
    setSnackbarMessageMessage(options.message)
    setSnackbarMessageSeverity(options.severity)
    setSnackbarMessageIsOpen(true)
  }

  const handleCloseChangeValueDialog = (valorTroco: bigint) => {
    if(isNaN(Number(valorTroco))) {
      valorTroco = BigInt(0)
    }
    //alert('fechando dialog troco')
    setChangeValue(valorTroco)
    setOpenChangeValueDialog(false)
  }

  const carregouTudo = shoppingBag && loginInfo
  const temItensNaSacola = (shoppingBag?.items?.length ?? -1) >= 1
  const placeEstaFechado = placeInfo?.closed ?? true

  return (
    <>
      <EditProfileDialog
        handleClose={handleCloseDialogEditProfile}
        open={openDialogEditProfile}
        id={loginInfo?.id ?? -1}
      />
      <PromptSendOrderViaWhatsapp
        handleClose={handleCloseSentViaWhatsAppDialog}
        open={openSentViaWhatsAppDialog}
        showSnackbarMessage={showSnackbarMessage}
        lastOrderState={lastOrderState}
      />
      <VideoDialog
        handleClose={handleCloseVideoDialog}
        open={openVideoDialog}
      />
      <EditTableNumberDialog
        handleClose={handleCloseEditTableNumberDialog}
        open={openEditTableNumberDialog}
        shoppingBagQuery={shoppingBagQuery}
      />
      <ChangeValueDialog
        open={openChangeValueDialog}
        trocoAtual={changeValue}
        handleClose={handleCloseChangeValueDialog}
        shoppingBagQuery={shoppingBagQuery}
        showSnackbarMessage={showSnackbarMessage}
        />

      {loginInfo && <CreateAddressDialog
        handleClose={handleCloseCreateAddressDialog}
        open={openCreateAddressDialog}
        loginInfo={loginInfo}
        shoppingBagQuery={shoppingBagQuery}
      />}

      <Drawer
        anchor={anchor ? anchor : "right"}
        open={open}
        onClose={() => {
          toggleDrawer();
        }}
      >
        <Snackbar
          open={snackbarMessageIsOpen}
          autoHideDuration={6000}
          onClose={handleCloseSnackbarMessage}
          anchorOrigin={{ horizontal: "center", vertical: "top" }}
        >
          <Alert
            onClose={handleCloseSnackbarMessage}
            severity={snackbarMessageSeverity}
            sx={{ width: "100%", marginTop: { md: "50px " } }}
          >
            {snackbarMessageMessage}
          </Alert>
        </Snackbar>

        {/* ATENÇÂO: temos várias condições para verificar, só DEVE renderizar UMA delas!!!*/}

        {placeEstaFechado  && <ShoppingBagPlaceFechado/>}

        {(!placeEstaFechado ) && !carregouTudo
          && <ShoppingBagSkeleton toggleDrawer={toggleDrawer} placeInfo={placeInfo} />}


        {(!placeEstaFechado ) && carregouTudo && !temItensNaSacola
          && <EmptyShoppingBag toggleDrawer={toggleDrawer} placeInfo={placeInfo}/>}


        {(!placeEstaFechado ) && carregouTudo && temItensNaSacola
            && <ShoppingBagData
            changeValue={changeValue}
            setChangeValue={setChangeValue}
            showSnackbarMessage={showSnackbarMessage}
            shoppingBag={shoppingBag}
            isRefetchingShoppingBag={isRefetchingShoppingBag || isLoadingShoppingBag}
            loginInfo={loginInfo}
            placeInfo={placeInfo}
            paymentTypesQuery={paymentTypesQuery}
            setOpenVideoDialog={setOpenVideoDialog}
            setOpenCreateAddressDialog={setOpenCreateAddressDialog}
            setOpenEditTableNumberDialog={setOpenEditTableNumberDialog}
            setOpenDialogEditProfile={setOpenDialogEditProfile}
            setOpenChangeValueDialog={setOpenChangeValueDialog}
            toggleDrawer={toggleDrawer}
            setOpenPromptSendOrderViaWhatsApp={setOpenSentViaWhatsAppDialog}
            setLastOrderState={setLastOrderState}
          />}
      </Drawer>
    </>
  );
}

export default ShoppingBag;
